module.exports = __webpack_public_path__ + "img/printer.3ef7b518.jpg";